module.exports = __webpack_public_path__ + "img/4.437185fb.jpg";